var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { config } from '../Config/Config';
var LocalAuth = /** @class */ (function () {
    function LocalAuth() {
    }
    LocalAuth.checkSession = function () {
        var token = LocalAuth.incomingSearch;
        if ((token === null || token === void 0 ? void 0 : token.token) && (token === null || token === void 0 ? void 0 : token.email)) {
            LocalAuth.setToken(token);
            return token;
        }
        else if (LocalAuth.isAuthed()) {
            return JSON.parse(localStorage.getItem(LocalAuth.TOKEN_KEY) || '{}');
        }
        else {
            throw 'Not Logged In';
        }
    };
    LocalAuth.isAuthed = function () {
        return !!localStorage.getItem(LocalAuth.TOKEN_KEY);
    };
    LocalAuth.redirectToLogin = function (origin) {
        LocalAuth.clearStorage();
        var url = config.get('actiniumUrl') + "home?origin=" + encodeURIComponent(origin);
        window.location.replace(url);
    };
    LocalAuth.redirectToLogout = function (origin) {
        LocalAuth.clearStorage();
        var url = config.get('actiniumUrl') + "logout?callback=" + encodeURIComponent(origin);
        window.location.replace(url);
    };
    LocalAuth.setToken = function (token) {
        try {
            localStorage.setItem(LocalAuth.TOKEN_KEY, JSON.stringify(token));
        }
        catch (e) {
            console.error(e);
        }
    };
    LocalAuth.setUser = function (user) {
        try {
            localStorage.setItem(LocalAuth.USER_KEY, JSON.stringify(user));
        }
        catch (e) {
            console.error(e);
        }
    };
    LocalAuth.setCompany = function (company) {
        try {
            localStorage.setItem(LocalAuth.COMPANY_KEY, JSON.stringify(company));
        }
        catch (e) {
            console.error(e);
        }
    };
    LocalAuth.getTokenValue = function () {
        var token;
        try {
            var tokenObject = JSON.parse(localStorage.getItem(LocalAuth.TOKEN_KEY) || '{}');
            token = tokenObject.token;
        }
        catch (e) {
            console.error(e);
        }
        return token;
    };
    LocalAuth.getEmail = function () {
        var email;
        try {
            var tokenObject = JSON.parse(localStorage.getItem(LocalAuth.TOKEN_KEY) || '{}');
            email = tokenObject.email;
        }
        catch (e) {
            console.error(e);
        }
        return email;
    };
    LocalAuth.getUser = function () {
        var user;
        try {
            user = JSON.parse(localStorage.getItem(LocalAuth.USER_KEY) || '{}');
        }
        catch (e) {
            console.error(e);
        }
        return user;
    };
    LocalAuth.clearStorage = function () {
        localStorage.removeItem(LocalAuth.TOKEN_KEY);
        localStorage.removeItem(LocalAuth.USER_KEY);
    };
    LocalAuth.getHashRouterQueryParameters = function (text) {
        return Object.assign.apply(Object, __spreadArrays([{}], (text || document.location.search)
            .replace(/(^\?)/, '')
            .replace('?', '&')
            .split('&')
            .map(function (n) {
            var _a;
            var split = n.split('=');
            return _a = {}, _a[decodeURIComponent(split[0])] = decodeURIComponent(split[1]), _a;
        })));
    };
    Object.defineProperty(LocalAuth, "incomingSearch", {
        get: function () {
            var params = new URLSearchParams(location.search);
            var token = {
                email: params.get('email'),
                token: params.get('token'),
            };
            if (!(token === null || token === void 0 ? void 0 : token.email) || !(token === null || token === void 0 ? void 0 : token.token)) {
                token = LocalAuth.getHashRouterQueryParameters(location.href);
            }
            return token;
        },
        enumerable: false,
        configurable: true
    });
    LocalAuth.TOKEN_KEY = "14747a245be4b9af82eaaf9222624650";
    LocalAuth.USER_KEY = "8339538f3b29160129590f4d02d94191";
    LocalAuth.COMPANY_KEY = "8339538f3b29160129590f4d02d94191";
    return LocalAuth;
}());
export default LocalAuth;
